import React, { Component } from 'react';
import { Redirect,Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {userGroupUrlCheck} from '../../../utils/userGroupUrlCheck';
import { URL_IMG } from '../../../configs/urlConfigs';
import { MSG_NOT_FOUND, MSG_KEY_LOCATION_REQUIRED, MSG_DEPARTMENT_REQUIRED, MSG_DEPARTMENT_ADD_SUCCESS, MSG_DEPARTMENT_UPDATE_SUCCESS, MSG_DEPARTMENT_DELETE_SUCCESS, MSG_DEPARTMENT_ADD_EDIT_DUPLICATE, MSG_ERROR } from '../../../configs/msgConfigs'; // 
import { LBL_APP_NAME, LBL_SETTINGS, LBL_DEPARTMENT, LBL_DEPARTMENTS, LBL_KEY_LOCATION, LBL_BTN_ADDNEW, LBL_SLNUM,LBL_CONFIRM_DELETE, LBL_BACK_TO_SETTINGS } from '../../../configs/labelConfigs';
import { ROUTE_AFFILIATE_REFRESH, ROUTE_AFFILIATE_SETTINGS} from '../../../configs/staticConfigs';
import { KEY_LOC_LIST_AFFILIATE_SUCCESS, DEPARTMENT_LIST_AFFILIATE_SUCCESS, DEPARTMENT_ADD_AFFILIATE_SUCCESS, DEPARTMENT_UPDATE_AFFILIATE_SUCCESS, DEPARTMENT_DELETE_AFFILIATE_SUCCESS, DEPARTMENT_ADD_AFFILIATE_ERROR, DEPARTMENT_UPDATE_AFFILIATE_ERROR, DEPARTMENT_DELETE_AFFILIATE_ERROR } from '../../../actions/';
// KEY_LOC_LIST_AFFILIATE_ERROR, DEPARTMENT_LIST_AFFILIATE_ERROR,     

import ModalWindow from '../../commons/helpers/modalWindow';
import Toast from '../../commons/helpers/toast';

import { formValid } from '../../../utils/validation';

import { aflt_departmentsListAction, aflt_departmentAddAction, aflt_departmentUpdateAction, aflt_departmentDeleteAction } from '../../../actions/settings/affiliates/aflt_departmentActions';

import { clearAction, aflt_keyLocationListAction } from '../../../actions/commonActions';

class DepartmentComponent extends Component { 

    constructor(props){
        super(props)

        this.state = {
            formErrors : {}, 
            keyLocationsList: [], 
            departmentsList: [],
            departmentData: {},
            selKeyLocationId:0,
            selDepartmentId:0,
            departmentName: '', 
            activeRowId: 0, 
            deptListErrMsg: '',
            formErrMsg_department: "",
            formErrMsg_keyLocation: "",
            formErrMsg_AddEdit: '', 
            sortField:'',
            sortOrder:'',
            toastMessage:'',
            toastFlag:false,
            toastSuccess:true,
            dptName:''
        }

        this.openModal = this.openModal.bind(this);
        this.onSaveFormData = this.onSaveFormData.bind(this);
        this.onShowActionButtons = this.onShowActionButtons.bind(this);
        this.onHideActionButtons = this.onHideActionButtons.bind(this);
        this.onHandleChange = this.onHandleChange.bind(this);
        this.onSort = this.onSort.bind(this);
        this.checkFormData = this.checkFormData.bind(this); 
        this.modalDelete = React.createRef();
        this.modalConfirmDelete = React.createRef();
        this.modal = React.createRef();
    }

    componentDidMount() { 
        document.body.classList.add('body-affiliate'); 
        document.title = LBL_APP_NAME+' - '+LBL_SETTINGS+' - '+LBL_DEPARTMENT; 
        this.props.aflt_departmentsListAction(); 
        setTimeout(()=> {
            this.props.aflt_keyLocationListAction();
        }, 500);        
    }   
    
    openModal(refId) { 
        if(this.state.selKeyLocationId===0) {
            this.setState({selDepartmentId:0, selKeyLocationId:0, departmentName:'', formErrMsg_department:"", formErrMsg_keyLocation:""});
        } 
        this.modal.current.handleOpenModal();
    }  

    onModalFormReset = () =>{   
        this.setState({selDepartmentId:0, selKeyLocationId:0, departmentName:'', formErrMsg_department:'', formErrMsg_keyLocation:''});   
        this.props.clearAction();  
    }

    onModalConfirmReset = () =>{
        this.modalDelete.current.handleModelClose();
        this.setState({selDepartmentId:0, selKeyLocationId:0, departmentName:'', formErrMsg_department:'', formErrMsg_keyLocation:''});   
        this.props.clearAction();  
    }

    onCloseToast = () =>{
        this.setState({toastFlag:false,toastMessage:''});
    }  

    onShowActionButtons = (event, rowId) =>{
        let dropdown     = document.getElementById('dropdown-'+rowId);
        let dropdownMenu = document.getElementById('dropdown-menu-'+rowId);
        dropdown.classList.toggle('show');
        dropdownMenu.classList.toggle('show');      

        if(this.state.activeRowId===0){   
            this.setState({activeRowId:rowId}); 
            document.getElementById('img-action-'+rowId).focus(); 
        }
        else if(this.state.activeRowId===rowId){ 
            this.setState({activeRowId:0}); 
        }
        else if(this.state.activeRowId!==rowId){   
            dropdown     = document.getElementById('dropdown-'+this.state.activeRowId);
            dropdownMenu = document.getElementById('dropdown-menu-'+this.state.activeRowId);
            dropdown.classList.toggle('show');
            dropdownMenu.classList.toggle('show');
            this.setState({activeRowId:rowId}); 
            document.getElementById('img-action-'+rowId).focus(); 
        }        
    }   
    
    onHideActionButtons = (event, rowId) =>{
        let dropdown     = document.getElementById('dropdown-'+rowId);
        let dropdownMenu = document.getElementById('dropdown-menu-'+rowId);
        dropdown.classList.remove('show');
        dropdownMenu.classList.remove('show');
        this.setState({activeRowId:0});
    }

    onSort = (event,sortKey) =>{        
        let sOrder = '';
        if(this.state.sortField===sortKey){         
            sOrder = (this.state.sortOrder==='-') ? '' : '-';
            this.props.aflt_appayrateListAction({column:sOrder+this.state.sortField});
            this.setState({ sortOrder:sOrder });            
        }else{
            this.setState({ sortField:sortKey });
            this.props.aflt_appayrateListAction({column:this.state.sortOrder+sortKey});
        }        
    }

    editBtnClick = (refId) =>{  
        this.props.departmentsList.forEach((rObj) => {
            if(refId===rObj.id) {
                this.setState({selDepartmentId:rObj.id, departmentName:rObj.name, selKeyLocationId:rObj.key_location_detail.id,   formErrMsg_department:'', formErrMsg_keyLocation:''}, () => {
                    this.openModal(rObj.id); 
                })
            }
        }); 
    }

    deleteBtnClick = (rowId,name) =>{
        this.setState({selDepartmentId: rowId,dptName:name}, () => this.modalDelete.current.handleOpenModal()); 
    }

    onDeleteAction = () =>{
        this.props.aflt_departmentDeleteAction({dptId:this.state.selDepartmentId});
    }

    onDeleteConfrimAction = () =>{
        this.props.aflt_departmentDeleteAction({dptId:this.state.selDepartmentId,confirm:true});              
    }
    
    onHandleChange = (event) =>{
        const {name, value} = event.target; 
        let errMsg = ''; 
        let valStr = value; //.trim(); 
        if(name==='sel_key_location') {  
            let sId = parseInt(valStr,10); 
            if(sId===0) errMsg = MSG_KEY_LOCATION_REQUIRED; 
            this.setState({ selKeyLocationId:sId, formErrMsg_keyLocation: errMsg });  
        }   
        else if(name==='txt_dept') { 
            if(valStr.trim()==='') errMsg = MSG_DEPARTMENT_REQUIRED; 
            this.setState({departmentName:valStr, formErrMsg_department: errMsg});  
        }  
    }  

    checkFormData() {
        if(this.state.departmentName.trim()==='') {  
            this.setState({formErrMsg_department:MSG_DEPARTMENT_REQUIRED});  
            return false; 
        } 
        else if(this.state.selKeyLocationId===0) {   
            this.setState({formErrMsg_keyLocation:MSG_KEY_LOCATION_REQUIRED});  
            return false; 
        }
        else {
            return true; 
        }
    }

    onSaveFormData = (refId) =>{
        if(formValid(this.state)){
            let deptName = this.state.departmentName.trim(); 
            let keyLocId = this.state.selKeyLocationId; 
            let userGroupData = userGroupUrlCheck(this.props.location);
            let grpProfileId = '';
            if(userGroupData!==undefined){
                grpProfileId = userGroupData.profile_id;
            }
            if(refId){ // EDIT 
                if(this.checkFormData()) { 
                    const checkDuplicate = obj => refId!==obj.id && obj.name === deptName.trim() && keyLocId===obj.key_location_detail.id;
                    if(this.props.departmentsList.some(checkDuplicate)){
                        this.setState({formErrMsg_department:MSG_DEPARTMENT_ADD_EDIT_DUPLICATE});
                    }else{
                        let affiliate = grpProfileId;
                        let editData= {
                            id: this.state.selDepartmentId, 
                            name: this.state.departmentName, 
                            key_location: this.state.selKeyLocationId,
                            affiliate: affiliate   
                        } 
                        this.props.aflt_departmentUpdateAction(editData);
                    }                    
                }
            }else if(this.checkFormData()) {
                const checkDuplicate = obj => obj.name === deptName.trim() && keyLocId===obj.key_location_detail.id;
                if(this.props.departmentsList.some(checkDuplicate)){
                    this.setState({formErrMsg_department:MSG_DEPARTMENT_ADD_EDIT_DUPLICATE});
                }else{
                    let affiliate = grpProfileId;
                    let addData= {
                        name: this.state.departmentName, 
                        key_location: this.state.selKeyLocationId,
                        affiliate: affiliate                        
                    } 
                    this.props.aflt_departmentAddAction(addData);
                }            
            }    
        }else{
            // let formErrors = this.state.formErrors;
            // if(this.state.sectorData.sectorName==null){
            //     formErrors.sectorName = MSG_SECTOR_REQUIRED;
            // }            
            // this.setState({formErrors});
        }
    }

    setToasterState(isEnabled,message,isSucces){
        this.setState({toastFlag:isEnabled,toastMessage:message,toastSuccess:isSucces});
        setTimeout(()=> {
            this.onCloseToast();
        }, 3000);
    }

    componentDidUpdate(prevProps) {       
        const { status,activity,errorData} = this.props;
        if (activity && (status !== prevProps.status || activity!==prevProps.activity)) {
            if(status!==401) {   
                var arrResp = activity.split('~~'); 
                var actString = arrResp[0]; 

                if(actString===KEY_LOC_LIST_AFFILIATE_SUCCESS){  
                    if(this.props.hasOwnProperty('keyLocationsList')) {
                        if(this.props.keyLocationsList.length===0) {
                            this.setState({keyLocationsList: []}); 
                        }
                        else {
                            this.setState({keyLocationsList: this.props.keyLocationsList}); 
                        }
                    } 
                    else {  
                        this.setState({keyLocationsList: []}); 
                    }
                } 
                else if(actString===DEPARTMENT_LIST_AFFILIATE_SUCCESS){
                    if(this.props.hasOwnProperty('departmentsList')) {
                        if(this.props.departmentsList.length===0) {
                            this.setState({departmentsList: [], deptListErrMsg: MSG_NOT_FOUND}); 
                        }
                        else {
                            this.setState({departmentsList: this.props.departmentsList, deptListErrMsg: ''}); 
                        }
                    } 
                    else {
                        this.setState({departmentsList: [], deptListErrMsg: MSG_NOT_FOUND}); 
                    }
                } 
                else if(actString===DEPARTMENT_ADD_AFFILIATE_SUCCESS){ 
                    this.onModalFormReset();
                    this.modal.current.handleModelClose();
                    this.setState({toastSuccess:true,toastFlag:true,toastMessage:MSG_DEPARTMENT_ADD_SUCCESS}, () => this.props.aflt_departmentsListAction());
                    setTimeout(()=> {
                        this.onCloseToast();
                    }, 3000);
                } 
                else if(actString===DEPARTMENT_ADD_AFFILIATE_ERROR) { 
                    let errMsg = MSG_ERROR;
                    this.setState({formErrMsg_AddEdit: errMsg, formErrMsg_department: '', formErrMsg_keyLocation: ''}); 
                } 
                else if(actString===DEPARTMENT_UPDATE_AFFILIATE_SUCCESS){ 
                    this.onModalFormReset();
                    this.modal.current.handleModelClose();
                    this.setState({departmentsList:this.props.departmentsList, toastSuccess:true, toastFlag:true,toastMessage:MSG_DEPARTMENT_UPDATE_SUCCESS}); 
                    setTimeout(()=> {
                        this.onCloseToast();
                    }, 3000);
                }
                else if(actString===DEPARTMENT_UPDATE_AFFILIATE_ERROR) { 
                    let errMsg = MSG_ERROR;
                    this.setState({formErrMsg_AddEdit: errMsg, formErrMsg_department: '', formErrMsg_keyLocation: ''}); 
                }  
                else if(actString===DEPARTMENT_DELETE_AFFILIATE_SUCCESS){ 
                    this.modalDelete.current.handleModelClose();
                    this.modalConfirmDelete.current.handleModelClose();
                    this.setState({toastSuccess:true, toastFlag:true,toastMessage:MSG_DEPARTMENT_DELETE_SUCCESS}, () => this.props.aflt_departmentsListAction());
                    setTimeout(()=> {
                        this.onCloseToast();
                    }, 3000);
                }
                else if(actString===DEPARTMENT_DELETE_AFFILIATE_ERROR) { 
                    if(status===424){
                        this.modalDelete.current.handleModelClose();
                        this.setToasterState(true,errorData.message,false);
                        // this.modalConfirmDelete.current.handleOpenModal();
                        // if(errorData.hasOwnProperty('confirmation_message')){
                        //     if(errorData.confirmation_message===true){
                        //         this.setState({selDepartmentId:errorData.id});
                        //     }else{
                        //         this.setState({selDepartmentId:0});
                        //     }
                        // }
                    }else{
                        this.modalDelete.current.handleModelClose();
                        this.setToasterState(true,JSON.stringify(errorData),false); 
                    }
                } 

            }
        }
    }
       
    render(){
        const { toastMessage,toastFlag,toastSuccess } = this.state

        const { status } = this.props;  

        if(status===401 || status===403){
            return <Redirect to={ROUTE_AFFILIATE_REFRESH} />;
        }

        return(
            <div className="col-md-8">
                <Toast toastDescription={toastMessage} toastFlag={toastFlag} toastSuccess={toastSuccess} closeToast={this.onCloseToast} />

                <div className="box">
                    <div className="box-head">
                        <div className='divFloatLeft padding-left-1 padding-right-20 padding-top-10 font-14'><Link to={ROUTE_AFFILIATE_SETTINGS}>{LBL_BACK_TO_SETTINGS}</Link></div>
                        <div className="to-right">
                        <button className="btn btn-primary launch-modal" onClick={this.openModal}>{LBL_BTN_ADDNEW}</button>
                        </div>
                    </div>

                    <div className="box-content">
                        <div className="table-responsive">
                            <table id="data-table" className="table" style={{width:"100%"}}>
                                <thead>
                                    <tr>
                                        {/* { onClick={(e) => this.onSort(e,'ap_from')} className="sorting_asc" } */}
                                        <th>{LBL_SLNUM}</th>
                                        <th>{LBL_DEPARTMENTS}</th>
                                        <th>{LBL_KEY_LOCATION}</th>
                                        <th className="action">&nbsp;</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                {(this.state.deptListErrMsg!=='') && 
                                    <tr key="errorMsg">
                                        <td colSpan="5" className="text-center">{this.state.deptListErrMsg}</td>
                                    </tr>
                                }
                                 {this.state.hasOwnProperty('departmentsList') && this.state.departmentsList.map((item,index) => { 
                                    return (
                                    <tr key={item.id}> 
                                        <td>{(index+1)}</td>
                                        <td>{item.name}</td>
                                        <td>{item.key_location_detail.location.location}</td>
                                        <td>
                                            <div className="dropdown" id={'dropdown-'+item.id}>
                                                <button className="dropdown-toggle" type="button" id={'dropdownMenuButton-'+item.id}  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"  onClick={(e) => this.onShowActionButtons(e, item.id)}
                                                 >
                                                <input type="image" id={"img-action-"+item.id} src={require('../../../'+URL_IMG+'action.png')} alt="Action" onBlur={(e) => this.onHideActionButtons(e, item.id)} ></input>
                                                </button>
                                                <div className="dropdown-menu" aria-labelledby={'dropdownMenuButton-'+item.id} id={'dropdown-menu-'+item.id}>
                                                <Link className="dropdown-item edit" to="#"  onMouseDown={(e) => this.editBtnClick(item.id)}>Edit</Link>
                                                <Link className="dropdown-item delete" to="#" onMouseDown={(e)=>this.deleteBtnClick(item.id,item.name)}>Delete</Link>
                                                </div>
                                            </div>
                                        </td>
                                        <td></td>
                                    </tr>
                                    ) } ) }
                                </tbody>
                            </table>
                            <div>&nbsp;</div>
                            <div>&nbsp;</div>
                            <br></br>
                        </div>
                    </div>
                </div>
                

                <ModalWindow ref={this.modalDelete} header={LBL_CONFIRM_DELETE} type="delete" deleteItem={this.onDeleteAction} resetModalForm={this.onModalFormReset}>
                    {"Are you sure you want to delete department '"+this.state.dptName+"'?"}

                </ModalWindow>

                <ModalWindow ref={this.modalConfirmDelete} header={LBL_CONFIRM_DELETE} type="confirm" deleteConfirmedItem={this.onDeleteConfrimAction} resetModalForm={this.onModalConfirmReset}>
                This department has already been used in another module, do you still want to delete this record?
                </ModalWindow>


                <ModalWindow ref={this.modal} header={"Add/Edit "+LBL_DEPARTMENT} saveFormData={ (e)=>this.onSaveFormData(this.state.selDepartmentId)} resetModalForm={this.onModalFormReset}> 
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Department</label>
                                <div className="text-input">
                                    <input type="text" placeholder="Department" name="txt_dept" value={this.state.departmentName} onChange={this.onHandleChange} maxLength = {120} className={(this.state.formErrMsg_department.length >0 ? "input-error" : ' ')} />
                                </div>
                                {/* {this.state.formErrMsg_department.length >0 && (
                                <div className="text-red left-align text-12">{this.state.formErrMsg_department}</div>
                                    )}   */}
                            </div>
                        </div> 
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Key Location</label>
                                <div className="form-group select-input">
                                    <select name="sel_key_location" id="sel_key_location" value={this.state.selKeyLocationId} onChange={this.onHandleChange} className={(this.state.formErrMsg_keyLocation.length >0 ? "input-error" : ' ')} >
                                        <option value="0">Select Location</option>
                                        {this.state.keyLocationsList.map((item,index) => { return (
                                            <option key={item.id} value={item.id} >{item.location.location}</option> )
                                        } ) }
                                    </select>
                                    {/* {this.state.formErrMsg_keyLocation.length >0 && (
                                    <div className="text-red left-align text-12">{this.state.formErrMsg_keyLocation}</div>
                                    )}  */}
                                </div>
                                {this.state.formErrMsg_AddEdit.length >0 && (
                                    <div className="text-red left-align text-12">{this.state.formErrMsg_AddEdit}........</div>
                                    )} 

                            </div>
                        </div>
                   </div> 
                </ModalWindow>
            </div>

        )
    }
}

const mapStateToProps = (state) => {
    return {
        keyLocationsList : state.afltDepartments.keyLocationsList,
        departmentsList : state.afltDepartments.departmentsList,
        departmentData : state.afltDepartments.departmentData,
        status:state.afltDepartments.status,
        activity:state.afltDepartments.activity,
        errorData: state.afltDepartments.errorData,
    } 
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        aflt_keyLocationListAction:data=>aflt_keyLocationListAction(data),
        aflt_departmentsListAction:data=>aflt_departmentsListAction(data),  
        aflt_departmentAddAction:data=>aflt_departmentAddAction(data),
        aflt_departmentUpdateAction:data=>aflt_departmentUpdateAction(data),
        aflt_departmentDeleteAction:id=>aflt_departmentDeleteAction(id),
        clearAction:clearAction
    },dispatch); 
} 
export default connect(mapStateToProps,mapDispatchToProps)(DepartmentComponent);


